import {
  AccountResponseT,
  ApplyEligibilityResponseT,
  ApplyEligibilityT,
} from '@consumer-frontend/nc-utils';

import { apiEndpoints } from '../lib/endpoints';
import { applyFetchers } from '../lib/swrConfig';

export const fetchAccount = (): Promise<AccountResponseT> => (
  applyFetchers.get(apiEndpoints.apply.account) as Promise<AccountResponseT>
);

export const fetchApplyEligibility = (): Promise<ApplyEligibilityResponseT> => (
  applyFetchers.get(apiEndpoints.apply.verifyEligibility) as Promise<ApplyEligibilityResponseT>
);

export const toApplyEligibility = (response: ApplyEligibilityResponseT): ApplyEligibilityT => ({
  applicationInLp: response.application_in_lp,
  dischargedLoan: response.discharged_loan,
  eligible: response.eligible,
  openLoan: response.open_loan,
});
